import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

const DateCell = ({value}) => {
    return (
        <>
            {format(new Date(value), 'EEEEEE dd LLL yyyy, HH:mm', {
                locale: enUS,
            })}
        </>
    )
}

export default DateCell;